
import React, {Fragment} from 'react';
import {
  CardDeck,
} from 'reactstrap'
import CompanyPanel from './CompanyPanel'
const rowCount = 3

const  SearchCardList = props => {
  const {hits, onClick} = props
  let cards = []
  let items = []
  for (let i=0; i < hits.length; i +=rowCount) {
    items = []
    for (let j=0; j < rowCount; ++j) {
      items[j] = hits[i+j]
    }
    cards.push (
      <Fragment key={i}>
        <CardDeck>
          {
            items.map((item, index) => {
              const value = item || {}
              const source = value._source || {}
              const companyId = source.companyId || value._id
            
              return (
                <Fragment key={index}>
                  <CompanyPanel source={source} onClick={onClick} companyId={companyId}/>
                </Fragment>
              )
            })
          }
        </CardDeck>
        <p/>
      </Fragment>
    )
  }
  return cards
}

export default SearchCardList
